import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ColDef, GridApi, GridOptions, GridReadyEvent, RowNode } from 'ag-grid-community';
import { EmpresasModel } from 'src/app/pages/configuracion/maestros/empresas/models/empresas-model';
import { GridColDefsSeguridadEmpresas } from '../../models/grid-col-defs-seguridad-empresas';

@Component({
  selector: 'app-grid-seguridad-empresas',
  templateUrl: './grid-seguridad-empresas.component.html',
  styleUrls: ['./grid-seguridad-empresas.component.css']
})
export class GridSeguridadEmpresasComponent implements OnInit {

  @Input() empresasData: EmpresasModel[] = [];
  api!: GridApi;
  apiCol: any;
  columnDefs: ColDef[] = new GridColDefsSeguridadEmpresas().columnDefs;
  gridOptions: GridOptions = {
    headerHeight: 0,
    onFirstDataRendered: (params) => {
      this.dataSeguridad.empresasSeleccionadas=this.dataSeguridad.empresasSeleccionadas.map(x=>x.id ?? x.Id);
      params.api.forEachNode(node => {
        if (this.dataSeguridad.empresasSeleccionadas.includes(node.data.codigoEmpresa)) node.setSelected(true);
      });
    }
  };
  @Input() filtroSeguridadFirmas: string = '';
  @Input() dataSeguridad: any;
  @Output() seleccionEmpresas: EventEmitter<any> = new EventEmitter<any>();
  overlayNoRowsTemplate: string ='<span>No se han encontrado empresas</span>';
  overlayLoadingTemplate: string ='<span class="ag-overlay-loading-center">Cargando...</span>';

  constructor() { }

  ngOnInit(): void {
  }

  cargaApi(arg: GridReadyEvent){
    this.api = arg.api;
    this.apiCol = arg.columnApi;
    this.api.sizeColumnsToFit();
  }

  selectRows(event: any){
   let empresasSeleccionadas = this.api.getSelectedRows();
   this.seleccionEmpresas.emit(empresasSeleccionadas);
  }

}
